<template>
    <div class="dashboard-activity-chart">
        <h4>Registreringer siste 14 dager</h4>
        <highcharts :options="chartOptions" :highcharts="Highcharts"></highcharts>
    </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import Highcharts from '../../highcharts';

export default {
    components: {
        highcharts: Chart,
    },
    created() {
        this.Highcharts = Highcharts;
    },
    data() {
        return {
            days: [],
        };
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    type: 'line',
                },
                title: {
                    text: null,
                },
                xAxis: {
                    categories: this.days.map(day => day.label),
                },
                yAxis: {
                    title: { text: 'Antall registreringer' },
                    min: 0,
                    allowDecimals: false,
                },
                series: [{
                    name: 'Registreringer',
                    data: this.days.map(day => day.count),
                }],
                credits: {
                    enabled: false,
                },
            };
        },
    },
    mounted() {
        this.fetchActivity();
    },
    methods: {
        async fetchActivity() {
            try {
                const response = await fetch('/api/v1/statistics/recent-activity');
                this.days = await response.json();
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>
